module.exports = __webpack_public_path__ + "static/media/b-sci-major-11_LR.af3beb52.jpg";